<template>
    <div class="flex items-center">
        <!-- eslint-disable vue/no-v-html -->
        <span v-html="model.status_dot" />
        <span class="ml-md">
            {{ model.status_label }}
        </span>
    </div>
</template>

<script>
    export default {
        props: {
            model: {
                type: Object,
                required: true,
            },
        },
    };
</script>
